import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import mapImage from '../../assets/images/contact/map.gif'

class Contact extends Component {
  render() {
    return (
      <div className="ch-contact" id="contact">
        <div className="container-lg">
          <h1
            className="display-4 text-center font-weight-bold mb-3"
            data-aos="zoom-in"
            data-aos-duration="2000"
          >
            <div className="text-icon">
              <FontAwesomeIcon icon="map-marked-alt" />
            </div>
            <span>แผนที่ & สถานที่</span>
          </h1>
          <p className="m-0 text-center text-secondary" data-aos="zoom-in" data-aos-duration="2000">
            99/99 ซอยปู่เชยธูปแก้ว ตำบลละหาร อำเภอบางบัวทอง จังหวัดนนทบุรี 11110
          </p>
          <p
            className="mb-5 text-center text-secondary"
            data-aos="zoom-in"
            data-aos-duration="2000"
          >
            99/99 Soi Pu Choei Thup Kaeo, Lahan, Bang Bua Thong District, Nonthaburi 11110
          </p>
          <div className="ch-location">
            <div className="ch-location-box" data-aos="fade-right" data-aos-duration="2000">
              <img className="img-fluid" src={mapImage} alt="chefhung-location" />
            </div>
            <iframe
              data-aos="fade-left"
              data-aos-duration="2000"
              title={'chefhung-map'}
              src={
                'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3872.071596047479!2d100.41267001483277!3d13.954342590216676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDU3JzE1LjYiTiAxMDDCsDI0JzUzLjUiRQ!5e0!3m2!1sen!2sth!4v1594104480011!5m2!1sen!2sth'
              }
              width={'100%'}
              height={480}
              frameBorder={0}
              style={{ border: 0 }}
              allowFullScreen
              aria-hidden={false}
              tabIndex={0}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Contact
